type Id = string | number | null;

export const BusinessUnitAPI = {
  businessUnits: '<%userArea%>/businessUnits',
  businessUnitById: (id?: Id) => `<%userArea%>/businessunits/${id}`,
  deleteBusinessUnit: (businessUnitId?: Id) => `api/v2/businessUnits/${businessUnitId}`,
  // GET (list) + PUT (full-replace) share one RESTful resource. See docs/adr/0003.
  integrationSettings: (businessUnitId?: Id) =>
    `api/v2/businessUnits/${businessUnitId}/integrationSettings`,
};
